/**
 * Shared react-intl rich-text chunk renderers for the AI Scanner conversation.
 *
 * The questions step and the results step render the same bold count into the
 * same scroll, so they share one renderer rather than each holding a copy that
 * could drift apart.
 */

/** Renders a count at the larger bold size shown in the design. */
export const renderCountChunk = (chunks) => (
  <span className="ai-scanner-message-count">{chunks}</span>
);
